<template>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const router = useRouter();
const route = useRoute();

onMounted(()=>{
    const path='/';
    router.push({ 
      path,
      query: { 
        _t: Date.now() // Add timestamp for cache busting
      }
    });
});

</script>